// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__aNwhl","hand":"Home_hand__HQYY5","wave":"Home_wave__eb3wd"};